import { motion } from "framer-motion";

export const ClinicalValidation = () => {
  return (
    <section 
      className="relative py-24 md:py-32 overflow-hidden border-y border-white/10"
      data-testid="clinical-section"
    >
      {/* Background image with overlay */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1657244358898-d9e110504fd8?crop=entropy&cs=srgb&fm=jpg&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-[#050505]/95" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        {/* Section header */}
        <div className="mb-16">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-mono text-sm tracking-[0.3em] text-[#E82D00] mb-4"
          >
            CLINICAL VALIDATION
          </motion.p>
          
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white mb-8"
            style={{ fontFamily: 'Oswald, sans-serif' }}
            data-testid="clinical-heading"
          >
            Clinically Validated
          </motion.h2>
        </div>

        {/* Content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="text-lg md:text-xl text-[#A3A3A3] leading-relaxed mb-6" data-testid="clinical-text-1">
              Creatine monohydrate requires no conversion and no activation.
            </p>
            <p className="text-lg md:text-xl text-[#E5E5E5] leading-relaxed" data-testid="clinical-text-2">
              Once absorbed, it is stored directly in muscle tissue as phosphocreatine, ready for immediate ATP regeneration during high-intensity exercise.
            </p>
          </motion.div>

          {/* Right: Stats */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="grid grid-cols-2 gap-6"
            data-testid="clinical-stats"
          >
            <div className="p-6 border border-white/10 bg-[#0A0A0A]/50">
              <p className="text-5xl md:text-6xl font-bold text-[#E82D00] mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
                100%
              </p>
              <p className="font-mono text-xs tracking-widest text-[#A3A3A3] uppercase">Pure Creatine</p>
            </div>
            <div className="p-6 border border-white/10 bg-[#0A0A0A]/50">
              <p className="text-5xl md:text-6xl font-bold text-white mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
                5g
              </p>
              <p className="font-mono text-xs tracking-widest text-[#A3A3A3] uppercase">Per Serving</p>
            </div>
            <div className="p-6 border border-white/10 bg-[#0A0A0A]/50">
              <p className="text-5xl md:text-6xl font-bold text-white mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
                0
              </p>
              <p className="font-mono text-xs tracking-widest text-[#A3A3A3] uppercase">Fillers</p>
            </div>
            <div className="p-6 border border-white/10 bg-[#0A0A0A]/50">
              <p className="text-5xl md:text-6xl font-bold text-white mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
                200
              </p>
              <p className="font-mono text-xs tracking-widest text-[#A3A3A3] uppercase">Servings</p>
            </div>
          </motion.div>
        </div>

        {/* Research badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-16 flex items-center gap-4"
        >
          <div className="w-12 h-12 flex items-center justify-center border border-[#E82D00] text-[#E82D00]">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="font-mono text-xs tracking-widest text-[#E82D00] uppercase mb-1">Pure & Effective</p>
            <p className="text-[#E5E5E5]">Supported by Clinical Research</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClinicalValidation;
